export default __webpack_public_path__ + "static/media/Time.7cfc0967.svg";